import React from 'react';
import ReactDOM from 'react-dom/client';
import './global.css';
import { App } from './routes';
import { createBrowserRouter, RouterProvider } from 'react-router';
import { SnowplowScript } from './services/tracking/snowplow-script';

// A data router enables navigation blocking for unsaved moderation choices.
const router = createBrowserRouter([
  {
    path: '*',
    element: (
      <>
        <SnowplowScript />
        <App />
      </>
    ),
  },
]);

ReactDOM.createRoot(document.getElementById('app') as HTMLElement).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);
